import React from 'react';
import { motion } from 'framer-motion';
import { Award, Globe, Heart } from 'lucide-react';
const reasons = [{
  icon: <Award className="w-10 h-10" data-id="element-198" />,
  title: '16+ Years of Excellence',
  description: "Maricopa's longest-standing and most trusted spa experience."
}, {
  icon: <Globe className="w-10 h-10" data-id="element-199" />,
  title: 'Internationally Trained',
  description: 'Karen continually travels to learn the latest techniques and advancements in esthetics.'
}, {
  icon: <Heart className="w-10 h-10" data-id="element-200" />,
  title: 'Fully Customized Care',
  description: 'Every treatment is tailored to your unique skin type, concerns, and goals.'
}];
export function WhyKBella() {
  return <section className="py-20 md:py-32 bg-gradient-to-b from-brand-white to-brand-blush" data-id="element-201">
      <div className="container mx-auto px-4 md:px-6" data-id="element-202">
        <div className="text-center mb-16" data-id="element-203">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading text-brand-charcoal mb-4" data-id="element-204">
            Why Clients Choose K'Bella
          </h2>
          <div className="w-16 h-1 bg-brand-coral mx-auto mt-6" data-id="element-205"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-16" data-id="element-206">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="flex flex-col items-center text-center" data-id="element-207">
              <div className="w-20 h-20 rounded-full bg-white shadow-md flex items-center justify-center text-brand-coral mb-6 relative" data-id="element-208">
                <div className="absolute inset-0 rounded-full border border-brand-coral/20 scale-110" data-id="element-209"></div>
                {reason.icon}
              </div>
              <h3 className="text-xl lg:text-2xl font-heading font-semibold text-brand-charcoal mb-4" data-id="element-210">
                {reason.title}
              </h3>
              <p className="text-brand-charcoal/70 leading-relaxed" data-id="element-211">
                {reason.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}